import { PageNotifications } from './Notifications';
import { PagePersonal } from './Personal';

export const USER = {
  Notifications: PageNotifications,
  Personal: PagePersonal,
} as const;
